module.exports = __webpack_public_path__ + "img/razy_rice.dd65dd50.png";